<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="calendar-tab" data-toggle="tab" href="#calendar" role="tab"
            aria-controls="calendar" aria-selected="false" (click)="onTabChange('calendar')">
            <h5 class="m-0"><strong>Calendar</strong></h5>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="tab-pending" data-toggle="tab" href="#table" role="tab" aria-controls="table"
            aria-selected="true" (click)="onTabChange('pending')">
            <h5 class="m-0"><strong>Pending Offers</strong></h5>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="tab-accepted" data-toggle="tab" href="#table" role="tab" aria-controls="table"
            aria-selected="true" (click)="onTabChange('accepted')">
            <h5 class="m-0"><strong>Accepted Offers</strong></h5>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="tab-denayed" data-toggle="tab" href="#table" role="tab" aria-controls="table"
            aria-selected="true" (click)="onTabChange('denayed')">
            <h5 class="m-0"><strong>Denayed Offers</strong></h5>
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="calendar" role="tabpanel" aria-labelledby="calendar-tab">
          <div class="p-3 innerContainer"
            style="border: 1px solid #dee2e6; border-top: none; background-color: #ffffff;">
            <div class="row mb-3">
              <div class="col text-left">
                <div class="btn btn-primary btn-sm" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                  (click)="changeMonth()">
                  Previous
                </div>
              </div>
              <div class="col text-center">
                <h3 style="margin: 0px;">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
              </div>
              <div class="col text-right">
                <div class="btn btn-primary btn-sm" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                  (click)="changeMonth()">
                  Next
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <mwl-calendar-month-view [viewDate]="viewDate" [events]="eventOffersCalendare"
                  (dayClicked)="dayClicked($event.day)" weekStartsOn="1">
                </mwl-calendar-month-view>
                <ng-container *ngIf="showResetDayButton">
                  <div class="row">
                    <div class="col text-center">
                      <hr />
                      <button type="button" class="btn btn-default btn-sm" (click)="resetDayFilterButtonClick()">Reset
                        Filter</button>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="showResetEventOfferFilterButton">
                  <div class="row">
                    <div class="col text-center">
                      <hr />
                      <button type="button" class="btn btn-default btn-sm" (click)="onEventOfferResetClick()">Reset
                        Filter</button>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="col">
                <table class="table text-center" id="month-sum-table">
                  <thead style="position: sticky; top: 0; z-index: 10; background-color: #ffffff;">
                    <tr>
                      <th style="background-color: #ffffff;"></th>
                      <th style="background-color: #ffffff;">Date</th>
                      <th style="background-color: #ffffff;">Weekday</th>
                      <th style="background-color: #ffffff;">Organization</th>
                      <th style="background-color: #ffffff;">Printers</th>
                      <th style="background-color: #ffffff;">Phones</th>
                      <th style="background-color: #ffffff;">Tablets</th>
                      <th style="background-color: #ffffff;">Router</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of eventOffersTable | keyvalue">
                      <tr *ngFor="let offer of eventOffersTable[item.key]; let i=index;"
                        [ngClass]="{'table-secondary': offer.id === choosenEventOfferId}">
                        <ng-container *ngIf="i < (eventOffersTable[item.key].length - 2); else emptyCellsTemplate">
                          <td><i class="fa {{offer.action.iconClass}}" data-toggle="tooltip" data-placement="top"
                              title="{{offer.action.actionName}}"></i></td>
                          <td>{{item.key | date:'d. MMM yy'}}</td>
                          <td>{{item.key | date:'EEEE'}}</td>
                          <td><strong [ngStyle]="{'color': offer.arrowColor}" (click)="onEventOfferClick(offer.id)"
                              style="cursor: pointer;">{{offer.eventName}}</strong> <a
                              href="offers/details/{{offer.id}}" target="_blank"><i
                                class="fa fa-external-link-alt"></i></a></td>
                        </ng-container>
                        <ng-template #emptyCellsTemplate>
                          <td colspan="4" class="text-left"><strong>{{offer.colspanName}}</strong></td>
                        </ng-template>
                        <td class="text-center {{offer.textColorClass}}"><i
                            class="fa {{offer.icon}}"></i>{{offer.hardwarePrinter}} <span
                            *ngIf="offer.rowColorClass === 'sum-row'"> / {{aviableHardwareCount.printerCount}}</span>
                        </td>
                        <td class="text-center {{offer.textColorClass}}"><i
                            class="fa {{offer.icon}}"></i>{{offer.hardwarePhone}} <span
                            *ngIf="offer.rowColorClass === 'sum-row'"> / {{aviableHardwareCount.phoneCount}}</span>
                        </td>
                        <td class="text-center {{offer.textColorClass}}"><i
                            class="fa {{offer.icon}}"></i>{{offer.hardwareTablet}} <span
                            *ngIf="offer.rowColorClass === 'sum-row'"> / {{aviableHardwareCount.tabletCount}}</span>
                        </td>
                        <td class="text-center {{offer.textColorClass}}"><i
                            class="fa {{offer.icon}}"></i>{{offer.hardwareRouter}} <span
                            *ngIf="offer.rowColorClass === 'sum-row'"> / {{aviableHardwareCount.routerCount}}</span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="table" role="tabpanel" aria-labelledby="table-tab">
          <div class="p-3 innerContainer"
            style="border: 1px solid #dee2e6; border-top: none; background-color: #ffffff;">
            <app-data-table pageSize="25" [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
              [filtersComponent]="dataFilters" (onReset)="onAfterTableReset()">
              <app-data-filters #dataFilters>
                <app-data-filter-group>
                  <app-data-filter-input label="Event Name" [(model)]="filters.eventName" placeholder="Event Name">
                  </app-data-filter-input>
                  <app-data-filter-input label="Client Name" [(model)]="filters.clientName" placeholder="Client Name">
                  </app-data-filter-input>
                  <app-data-filter-datepicker label="Created from" [(model)]="filters.createdFrom">
                  </app-data-filter-datepicker>
                  <app-data-filter-datepicker label="Created to" [(model)]="filters.createdTo">
                  </app-data-filter-datepicker>
                </app-data-filter-group>
              </app-data-filters>
            </app-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #offerIdColumn let-offerId="offerId">
    <strong>{{offerId}}</strong>
  </ng-template>

  <ng-template #versionLetterColumn let-versionLetter="versionLetter">
    {{versionLetter}}
  </ng-template>

  <ng-template #eventNameColumn let-eventName="eventName">
    {{eventName}}
  </ng-template>

  <ng-template #statusColumn let-status="status">
    {{status | eventOfferStatus}}
  </ng-template>

  <ng-template #startDateColumn let-startDate="startDate">
    {{startDate | date:'dd-MM-yyyy'}}
  </ng-template>

  <ng-template #endDateColumn let-endDate="endDate">
    {{endDate | date:'dd-MM-yyyy'}}
  </ng-template>

  <ng-template #clientNameColumn let-clientName="clientName">
    {{(clientName && clientName!=="undefined undefined" ? clientName : '')}}
  </ng-template>

  <ng-template #organizationNameColumn let-organizationName="organizationName" let-company="company">
    {{(organizationName ? organizationName : company.name)}}
  </ng-template>

  <ng-template #villageColumn let-village="village" let-company="company">
    @if (village) {
      {{village.name}}
    } @else if (company?.village) {
      {{company.village.name}}
    } @else {
      -
    }
  </ng-template>

  <ng-template #zoneColumn let-zone="zone">
    {{zone}}
  </ng-template>

  <ng-template #fullPriceColumn let-fullPrice="fullPrice">
    {{fullPrice | currency: '€ '}}
  </ng-template>

  <ng-template #discountedPriceColumn let-discountedPrice="discountedPrice">
    {{discountedPrice | currency: '€ '}}
  </ng-template>

  <ng-template #createdAtColumn let-createdAt="createdAt">
    {{createdAt | date:'dd-MM-yyyy HH:mm'}}
  </ng-template>

  <ng-template #documentsColumn let-offerId="offerId" let-versionLetter="versionLetter">
    <button type="button" class="btn btn-sm btn-default" (click)="downloadEventOfferPdf(offerId, versionLetter)"><i
        class="fa fa-file-pdf"></i></button>
  </ng-template>

  <ng-template #actionsColumn let-id="id">
    <div class="btn-group navbar p-0" style="flex-wrap: nowrap;">
      <a href="offers/details/{{id}}" class="btn btn-secondary btn-sm" style="height: 50px"><i class="fa fa-search-plus"></i>
        View</a>
      <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px; height: 50px">
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <button type="button" class="dropdown-item btn-sm" (click)="onDeletePriceListClickEvent(id)"><i
            class="fa fa-trash-alt"></i>Delete</button>
      </div>
    </div>
  </ng-template>
  <app-confirm-dialog-model #confirmDeleteOfferDialog (getResult)="deleteEventOffer($event)" modalTitle="Delete Offer"
    modalContent="Do you want to delete this Offer?" denyText="No" acceptText="Yes">
  </app-confirm-dialog-model>
</div>
